import React  from "react";
import { useSelector} from "react-redux";

import { modifyonelead } from "../../utils/actions_lead";
import filtreformules from "../../utils/needsfilter";

import './Besoins.scss' ;

const classNames = require('classnames');    


let jsonliste ={"need_hospi":"Hospitalisation","need_specialiste":"Consultations",
                "need_lunettes":"Lunettes","need_lentilles":"Lentilles",
                "need_protheses":"Soins dentaires","need_implant":"Implants",
                "need_orthodontie":"Orthodontie","need_prevention":"Prévention"}

let jsonnominations ={"need_hospi":['100-150%','> 150%'],"need_specialiste":['100-150%','> 150%'],
                    "need_lunettes":['Besoin faible','Important'],"need_lentilles":['Besoin faible','Important'],
                    "need_protheses":['100-150%','> 150%'],"need_implant":['Besoin faible','Important'],
                    "need_orthodontie":['100-150%',`> 150%`],"need_prevention":['Besoin faible','Important']}

function Besoins(){
    const ficheclient = useSelector(state=>state.lead.leadactu);

   const definebesoin = (besoin,x)=>{
        modifyonelead({...ficheclient,[besoin]:x}); filtreformules({...ficheclient,[besoin]:x}) ;
    }

    return( <><div className="tabloneeds" >
            {Object.keys(jsonliste).map(besoin=><div key={besoin} className="tabloneeds_colonne">
                                                        <div>{jsonliste[besoin]}</div>
                                                        <div className={classNames("pasdebesoin",{"besoindef":ficheclient[besoin]===0})} onClick={()=>{definebesoin(besoin,0)}}>Pas de besoins</div>
                                                        <div className={classNames("petitbesoin",{"besoindef":ficheclient[besoin]===1})} onClick={()=>{definebesoin(besoin,1)}}>{jsonnominations[besoin][0]}</div>
                                                        <div className={classNames("grosbesoin",{"besoindef":ficheclient[besoin]===2})}  onClick={()=>{definebesoin(besoin,2)}}>{jsonnominations[besoin][1]}</div>
                </div>)}
            </div>
    </> );


}


export default Besoins